{
  "$schema": "../../../docs/schemas/ui-route-manifest.schema.json",
  "version": 1,
  "reactBasePath": "/next",
  "routes": [
    {
      "id": "home",
      "canonical": "/",
      "aliases": [],
      "certified": true,
      "shell": "community"
    },
    {
      "id": "authentication-action",
      "canonical": "/authentication/{action}",
      "aliases": [],
      "certified": true,
      "shell": "community"
    },
    {
      "id": "command-claims",
      "canonical": "/command/claims",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-content-gallery",
      "canonical": "/command/content/gallery",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-content-images",
      "canonical": "/command/content/images",
      "aliases": ["/command/content/images/{Group}"],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-content",
      "canonical": "/command/content",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-content-page-edit",
      "canonical": "/command/content/pages/{Slug}/edit",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-content-page",
      "canonical": "/command/content/pages/{Slug}",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-content-pages",
      "canonical": "/command/content/pages",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-field-report-edit",
      "canonical": "/command/field-reports/create",
      "aliases": ["/command/field-reports/{ReportId:guid}"],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-field-reports",
      "canonical": "/command/field-reports",
      "aliases": ["/command/wiki-media"],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-hosting-finance",
      "canonical": "/command/hosting-finance",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-hosting-finance-account",
      "canonical": "/command/hosting-finance/accounts/{CostOwnerId:guid}",
      "aliases": [],
      "certified": true,
      "shell": "command",
      "classicFallback": "/command/hosting-finance"
    },
    {
      "id": "command-hosting-finance-settings",
      "canonical": "/command/hosting-finance/settings",
      "aliases": [],
      "certified": true,
      "shell": "command",
      "classicFallback": "/command/hosting-finance"
    },
    {
      "id": "command",
      "canonical": "/command",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-member",
      "canonical": "/command/members/{UserId:guid}",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-members",
      "canonical": "/command/members",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-role",
      "canonical": "/command/roles/{RoleId:long}",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-roles",
      "canonical": "/command/roles",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-settings",
      "canonical": "/command/settings",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-verein-document-edit",
      "canonical": "/command/verein/documents/{DocumentId:long}/edit",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-verein-document",
      "canonical": "/command/verein/documents/{DocumentId:long}",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-verein-document-create",
      "canonical": "/command/verein/documents/create",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-verein-documents",
      "canonical": "/command/verein/documents",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-verein-kassenbuch-edit",
      "canonical": "/command/verein/kassenbuch/{EntryId:long}/edit",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-verein-kassenbuch-create",
      "canonical": "/command/verein/kassenbuch/create",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-verein-kassenbuch",
      "canonical": "/command/verein/kassenbuch",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-membership-requests",
      "canonical": "/command/verein/membership-requests",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-verein-settings",
      "canonical": "/command/verein/settings",
      "aliases": ["/command/settings/verein", "/command/association/settings"],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "mod-pack",
      "canonical": "/command/mod-packs/{ModPackId:long}",
      "aliases": [
        "/data/mod-packs/{ModPackId:long}",
        "/command/mod-packs/{ModPackId:long}/{Section}"
      ],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "mod-packs",
      "canonical": "/command/mod-packs",
      "aliases": ["/data/mod-packs/all"],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "mod-pack-create",
      "canonical": "/command/mod-packs/create",
      "aliases": ["/data/mod-packs/create"],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "terrain",
      "canonical": "/command/terrains/{TerrainId:long}",
      "aliases": ["/data/terrains/{TerrainId:long}"],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "terrains",
      "canonical": "/command/terrains",
      "aliases": ["/data/terrains/all"],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "terrain-create",
      "canonical": "/command/terrains/create",
      "aliases": ["/data/terrains/create"],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "event-detail",
      "canonical": "/events/{EventId:guid}",
      "aliases": [],
      "certified": true,
      "shell": "community"
    },
    {
      "id": "command-events",
      "canonical": "/command/events",
      "aliases": ["/events/all"],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-event-create",
      "canonical": "/command/events/create",
      "aliases": ["/events/create"],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "command-event-edit",
      "canonical": "/command/events/{EventId:guid}",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "events-upcoming",
      "canonical": "/events/upcoming",
      "aliases": [],
      "certified": true,
      "shell": "community"
    },
    {
      "id": "field-report",
      "canonical": "/field-reports/{Slug}",
      "aliases": ["/media/{Slug}"],
      "certified": false,
      "shell": "community"
    },
    {
      "id": "gdpr",
      "canonical": "/gdpr",
      "aliases": [],
      "certified": false,
      "shell": "community"
    },
    {
      "id": "join",
      "canonical": "/join",
      "aliases": ["/members"],
      "certified": true,
      "shell": "community"
    },
    {
      "id": "field-reports",
      "canonical": "/field-reports",
      "aliases": ["/media"],
      "certified": true,
      "shell": "community"
    },
    {
      "id": "configuration-profiles",
      "canonical": "/command/configuration-profiles",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "configuration-profile-create",
      "canonical": "/command/configuration-profiles/create",
      "classicFallback": "/command/configuration-profiles",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "configuration-profile",
      "canonical": "/command/configuration-profiles/{ProfileId:guid}",
      "classicFallback": "/command/configuration-profiles",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "server-create",
      "canonical": "/command/servers/create",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "server",
      "canonical": "/command/servers/{ServerId:guid}",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "servers",
      "canonical": "/command/servers",
      "aliases": [],
      "certified": true,
      "shell": "command"
    },
    {
      "id": "account-settings",
      "canonical": "/settings",
      "aliases": [],
      "certified": true,
      "shell": "community"
    },
    {
      "id": "verein-minute",
      "canonical": "/verein/beschluesse/{DocumentId:long}",
      "aliases": ["/unit/beschluesse/{DocumentId:long}"],
      "certified": true,
      "shell": "community"
    },
    {
      "id": "verein-minutes",
      "canonical": "/verein/beschluesse",
      "aliases": ["/unit/beschluesse"],
      "certified": true,
      "shell": "community"
    },
    {
      "id": "unit",
      "canonical": "/unit",
      "aliases": [],
      "certified": true,
      "shell": "community"
    },
    {
      "id": "verein-ledger",
      "canonical": "/verein/kassenbuch",
      "aliases": ["/unit/kassenbuch"],
      "certified": false,
      "shell": "community"
    },
    {
      "id": "verein-statutes",
      "canonical": "/verein/satzung",
      "aliases": ["/unit/satzung"],
      "certified": true,
      "shell": "community"
    },
    {
      "id": "verein",
      "canonical": "/verein",
      "aliases": [],
      "certified": true,
      "shell": "community"
    },
    {
      "id": "wiki",
      "canonical": "/wiki",
      "aliases": ["/wiki/{PageId:guid}"],
      "certified": true,
      "shell": "community"
    }
  ]
}
